'use strict';

var _ = require('lodash');
var GridRecordsNavigationService = function GridRecordsNavigationService() {
  var dmParentAllRows;
  var dmParentKeyColumn;
  var dmParentSelectedRowIndexes;
  var dmParentSelectionFilters;
  var dmParentAllRowFilters;
  var dmParentMultipleKeySelected;
  var demandManagementGridDisplayed;
  var dmParentTabTitle;
  var parentAllRows;
  var parentSelectedRowIndexes;
  var parentKeyColumn;
  var parentSelectionFilters;
  var parentAllRowFilters;
  var parentMultipleKeySelected;
  var parentGridPrevKeyDisabled;
  var parentGridNextKeyDisabled;
  var parentTabTitle;
  var marketGridVisibleMode;
  var gridIdToMode = {
    'market-demand-analysis': 'market',
    'market-product-group-analysis': 'market-product-group',
    'service-demand-analysis': 'service'
  };
  function getLastIndexOfAKey(rowIndex, key, allRowFilters) {
    var selectedGridData = allRowFilters[rowIndex];
    var lastIndex = rowIndex;
    for (var index = lastIndex; index < allRowFilters.length; index++) {
      var row = allRowFilters[index];
      if (!_.isEqual(_.pick(row, key), _.pick(selectedGridData, key))) {
        break;
      }
      lastIndex = index;
    }
    return lastIndex;
  }
  function getFirstIndexOfAKey(rowIndex, key, allRowFilters) {
    var selectedGridData = allRowFilters[rowIndex];
    var firstIndex = rowIndex;
    for (var index = firstIndex; index > -1; index--) {
      var row = allRowFilters[index];
      if (!_.isEqual(_.pick(row, key), _.pick(selectedGridData, key))) {
        break;
      }
      firstIndex = index;
    }
    return firstIndex;
  }
  function isRowSelected(selectedRowIndexes) {
    return selectedRowIndexes && selectedRowIndexes.length > 0;
  }
  function isPreviousKeyButtonDisabled(selectedRowIndexes, key, allRowFilters) {
    if (isRowSelected(selectedRowIndexes)) {
      var firstKeyLastIndex = getLastIndexOfAKey(0, key, allRowFilters);
      var minSelectedRowIndex = _.first(selectedRowIndexes);
      var minSelectedRowFirstIndex = getFirstIndexOfAKey(minSelectedRowIndex, key, allRowFilters);
      return minSelectedRowIndex <= firstKeyLastIndex && minSelectedRowFirstIndex === 0;
    }
  }
  function isNextKeyButtonDisabled(selectedRowIndexes, key, allRowFilters) {
    if (isRowSelected(selectedRowIndexes)) {
      var lastKeyFirstIndex = getFirstIndexOfAKey(allRowFilters.length - 1, key, allRowFilters);
      var maxSelectedRowIndex = _.last(selectedRowIndexes);
      var maxSelectedRowLastIndex = getLastIndexOfAKey(maxSelectedRowIndex, key, allRowFilters);
      return maxSelectedRowIndex >= lastKeyFirstIndex && maxSelectedRowLastIndex === allRowFilters.length - 1;
    }
  }
  function isMultipleKeysSelected(selectedRowIndexes, key, selectionFilters) {
    if (!isRowSelected(selectedRowIndexes)) {
      return undefined;
    }
    var uniqueElements = [];
    var i = selectionFilters.length;
    while (i--) {
      var selectionFilter = selectionFilters[i];
      var u = uniqueElements.length;
      var isUnique = true;
      while (u--) {
        var uniqueElement = uniqueElements[u];
        if (_.isEqual(_.pick(selectionFilter, key), _.pick(uniqueElement, key))) {
          isUnique = false;
          u = 0;
        }
      }
      if (isUnique) {
        uniqueElements.push(selectionFilter);
      }
      if (uniqueElements.length > 1) {
        return true;
      }
    }
    return false;
  }
  function isPreviousRecordButtonDisabled(selectedRowIndexes) {
    return _.min(selectedRowIndexes) <= 0;
  }
  function isNextRecordButtonDisabled(gridData, selectedRowIndexes) {
    return _.max(selectedRowIndexes) >= gridData.length - 1;
  }
  function getPreviousRowIndex(selectedRowIndexes) {
    if (selectedRowIndexes && selectedRowIndexes.length === 0) {
      selectedRowIndexes = [0];
    }
    var minSelectedIndex = _.min(selectedRowIndexes);
    return minSelectedIndex === 0 ? 0 : minSelectedIndex - 1;
  }
  function getNextRowIndex(gridData, selectedRowIndexes) {
    if (selectedRowIndexes && selectedRowIndexes.length === 0) {
      selectedRowIndexes = [0];
    }
    var maxSelectedIndex = _.max(selectedRowIndexes);
    var lastIndex = gridData.length - 1;
    return maxSelectedIndex === lastIndex ? lastIndex : maxSelectedIndex + 1;
  }
  function getPreviousKeyIndex(selectedRowIndexes, key, allRowFilters) {
    if (selectedRowIndexes && selectedRowIndexes.length === 0) {
      selectedRowIndexes = [0];
    }
    var minSelectedIndex = _.first(selectedRowIndexes);
    return getFirstIndexOfAKey(minSelectedIndex, key, allRowFilters) - 1;
  }
  function getNextKeyIndex(selectedRowIndexes, key, allRowFilters) {
    if (selectedRowIndexes && selectedRowIndexes.length === 0) {
      selectedRowIndexes = [0];
    }
    var maxSelectedIndex = _.last(selectedRowIndexes);
    return getLastIndexOfAKey(maxSelectedIndex, key, allRowFilters) + 1;
  }
  function getParentNextKeyRows() {
    var maxSelectedRowIndex = _.last(parentSelectedRowIndexes);
    var lastIndexOfCurrentKey = getLastIndexOfAKey(maxSelectedRowIndex, parentKeyColumn, parentAllRowFilters);
    var firstIndexOfNextKey = lastIndexOfCurrentKey + 1;
    if (firstIndexOfNextKey < parentAllRows.length) {
      return [parentAllRowFilters[firstIndexOfNextKey]];
    }
  }
  function getParentPreviousKeyRows() {
    var minSelectedRowIndex = _.first(parentSelectedRowIndexes);
    var firstIndexOfCurrentKey = getFirstIndexOfAKey(minSelectedRowIndex, parentKeyColumn, parentAllRowFilters);
    var lastIndexOfPrevKey = firstIndexOfCurrentKey - 1;
    if (lastIndexOfPrevKey >= 0) {
      return [parentAllRowFilters[lastIndexOfPrevKey]];
    }
  }
  function returnSelectedKeyRows(firstIndex, lastIndex, allRows) {
    var selectedRowData = [];
    _.forEach(_.range(firstIndex, lastIndex + 1), function (index) {
      selectedRowData.push(allRows[index]);
    });
    return selectedRowData;
  }
  function setParentGridInformation(allRows, selectedRowIndexes, keyColumn, selectionFilters, allRowFilters) {
    parentAllRows = allRows;
    parentSelectedRowIndexes = selectedRowIndexes;
    parentKeyColumn = keyColumn;
    parentSelectionFilters = selectionFilters;
    parentAllRowFilters = allRowFilters;
    parentMultipleKeySelected = isMultipleKeysSelected(selectedRowIndexes, keyColumn, parentSelectionFilters);
    parentGridPrevKeyDisabled = isPreviousKeyButtonDisabled(selectedRowIndexes, keyColumn, parentAllRowFilters);
    parentGridNextKeyDisabled = isNextKeyButtonDisabled(selectedRowIndexes, keyColumn, parentAllRowFilters);
  }
  function isParentMultipleKeySelected() {
    return parentMultipleKeySelected;
  }
  function isParentGridPrevKeyDisabled() {
    return parentGridPrevKeyDisabled;
  }
  function isParentGridNextKeyDisabled() {
    return parentGridNextKeyDisabled;
  }
  function isParentTab(gridId) {
    return _.includes(['market-demand-analysis', 'cabin-flight-da-analysis', 'cabin-flight-analysis', 'cabin-flight-analysis-post-departure', 'flight-summary'], gridId);
  }
  function setParentTabTitle(title) {
    parentTabTitle = title;
  }
  function getParentTabTitle() {
    return parentTabTitle;
  }
  function determinePreviousKeyButtonVisibility(gridData, selectedRowIndexes, rowKey, allRowFilters, gridId) {
    if (!parentSelectedRowIndexes || parentSelectedRowIndexes.length === 0 || isParentMultipleKeySelected() || isFlightManagementGrid(gridId)) {
      if (gridData && getLastIndexOfAKey(0, rowKey, allRowFilters) < gridData.length) {
        return isPreviousKeyButtonDisabled(selectedRowIndexes, rowKey, allRowFilters);
      }
      return false;
    }
    return isParentGridPrevKeyDisabled();
  }
  function determineNextKeyButtonVisibility(gridData, selectedRowIndexes, rowKey, allRowFilters, gridId) {
    if (!parentSelectedRowIndexes || parentSelectedRowIndexes.length === 0 || isParentMultipleKeySelected() || isFlightManagementGrid(gridId)) {
      if (gridData && getLastIndexOfAKey(0, rowKey, allRowFilters) < gridData.length) {
        return isNextKeyButtonDisabled(selectedRowIndexes, rowKey, allRowFilters);
      }
      return false;
    }
    return isParentGridNextKeyDisabled();
  }
  function determineDMPreviousKeyButtonVisibility() {
    if (dmParentAllRows && dmParentSelectedRowIndexes && dmParentSelectedRowIndexes.length > 0) {
      return isPreviousKeyButtonDisabled(dmParentSelectedRowIndexes, dmParentKeyColumn, dmParentAllRowFilters);
    }
    return false;
  }
  function determineDMNextKeyButtonVisibility() {
    if (dmParentAllRows && dmParentSelectedRowIndexes && dmParentSelectedRowIndexes.length > 0) {
      return isNextKeyButtonDisabled(dmParentSelectedRowIndexes, dmParentKeyColumn, dmParentAllRowFilters);
    }
    return false;
  }
  function setDMParentGridInformation(allRows, selectedRowIndexes, keyColumn, selectionFilters, allRowFilters) {
    dmParentAllRows = allRows;
    dmParentKeyColumn = keyColumn;
    dmParentSelectedRowIndexes = selectedRowIndexes;
    dmParentSelectionFilters = selectionFilters;
    dmParentAllRowFilters = allRowFilters;
    dmParentMultipleKeySelected = isMultipleKeysSelected(selectedRowIndexes, keyColumn, dmParentSelectionFilters);
  }
  function isDMParentMultipleKeySelected() {
    return dmParentMultipleKeySelected;
  }
  function getDMParentNextKeyRows() {
    var maxSelectedRowIndex = _.last(dmParentSelectedRowIndexes);
    var lastIndexOfCurrentKey = getLastIndexOfAKey(maxSelectedRowIndex, dmParentKeyColumn, dmParentAllRowFilters);
    var firstIndexOfNextKey = lastIndexOfCurrentKey + 1;
    if (firstIndexOfNextKey < dmParentAllRows.length) {
      var lastIndexOfNextKey = getLastIndexOfAKey(firstIndexOfNextKey, dmParentKeyColumn, dmParentAllRowFilters);
      return returnSelectedKeyRows(firstIndexOfNextKey, lastIndexOfNextKey, dmParentAllRows);
    }
  }
  function getDMPreviousKeyRows() {
    var minSelectedRowIndex = _.first(dmParentSelectedRowIndexes);
    var firstIndexOfCurrentKey = getFirstIndexOfAKey(minSelectedRowIndex, dmParentKeyColumn, dmParentAllRowFilters);
    var lastIndexOfPrevKey = firstIndexOfCurrentKey - 1;
    if (lastIndexOfPrevKey >= 0) {
      var firstIndexOfPrevKey = getFirstIndexOfAKey(lastIndexOfPrevKey, dmParentKeyColumn, dmParentAllRowFilters);
      return returnSelectedKeyRows(firstIndexOfPrevKey, lastIndexOfPrevKey, dmParentAllRows);
    }
  }
  function setDMParentTabTitle(title) {
    dmParentTabTitle = title;
  }
  function getDMParentTabTitle() {
    return dmParentTabTitle;
  }
  var buttonState = function buttonState(gridData, selectedRowIndexes, rowKey, gridId, selectionFilters, allRowFilters) {
    if (selectedRowIndexes && selectedRowIndexes.length === 0 && gridData && gridData.length > 0) {
      selectedRowIndexes = [0];
      selectionFilters = [allRowFilters[0]];
    }
    if (isDemandManagementGrid(gridId) && dmParentAllRows && dmParentAllRows.length > 0) {
      return {
        disablePreviousKeyButton: determineDMPreviousKeyButtonVisibility(),
        disablePreviousRowButton: gridData ? isPreviousRecordButtonDisabled(selectedRowIndexes) : false,
        disableNextRowButton: gridData ? isNextRecordButtonDisabled(gridData, selectedRowIndexes) : false,
        disableNextKeyButton: determineDMNextKeyButtonVisibility()
      };
    }
    return {
      disablePreviousKeyButton: determinePreviousKeyButtonVisibility(gridData, selectedRowIndexes, rowKey, allRowFilters, gridId),
      disablePreviousRowButton: gridData ? isPreviousRecordButtonDisabled(selectedRowIndexes) : false,
      disableNextRowButton: gridData ? isNextRecordButtonDisabled(gridData, selectedRowIndexes) : false,
      disableNextKeyButton: determineNextKeyButtonVisibility(gridData, selectedRowIndexes, rowKey, allRowFilters, gridId)
    };
  };
  function setMarketGridVisibleMode(gridId) {
    marketGridVisibleMode = gridIdToMode[gridId];
  }
  function getMarketGridVisibleMode() {
    return marketGridVisibleMode;
  }
  function isMarketProductOrService() {
    return marketGridVisibleMode && (marketGridVisibleMode === 'market-product-group' || marketGridVisibleMode === 'service');
  }
  function getDemandManagementGridDisplayed() {
    return demandManagementGridDisplayed;
  }
  function setDemandManagementGridDisplayed(isGridDisplayed) {
    demandManagementGridDisplayed = isGridDisplayed;
  }
  function isFlightManagementGrid(gridId) {
    return _.includes(['flight-summary'], gridId);
  }
  function isDemandManagementGrid(gridId) {
    return demandManagementGridDisplayed && (gridId === 'market-demand-analysis' || gridId === 'market-product-group-analysis' || gridId === 'service-demand-analysis');
  }
  return {
    getPreviousRowIndex: getPreviousRowIndex,
    getNextRowIndex: getNextRowIndex,
    getPreviousKeyIndex: getPreviousKeyIndex,
    getNextKeyIndex: getNextKeyIndex,
    getParentNextKeyRows: getParentNextKeyRows,
    getParentPreviousKeyRows: getParentPreviousKeyRows,
    setParentGridInformation: setParentGridInformation,
    isParentMultipleKeySelected: isParentMultipleKeySelected,
    isParentGridPrevKeyDisabled: isParentGridPrevKeyDisabled,
    isParentGridNextKeyDisabled: isParentGridNextKeyDisabled,
    isParentTab: isParentTab,
    setParentTabTitle: setParentTabTitle,
    getParentTabTitle: getParentTabTitle,
    setMarketGridVisibleMode: setMarketGridVisibleMode,
    getMarketGridVisibleMode: getMarketGridVisibleMode,
    isMarketProductOrService: isMarketProductOrService,
    buttonState: buttonState,
    setDemandManagementGridDisplayed: setDemandManagementGridDisplayed,
    getDemandManagementGridDisplayed: getDemandManagementGridDisplayed,
    isDemandManagementGrid: isDemandManagementGrid,
    setDMParentGridInformation: setDMParentGridInformation,
    getDMParentNextKeyRows: getDMParentNextKeyRows,
    getDMParentPreviousKeyRows: getDMPreviousKeyRows,
    setDMParentTabTitle: setDMParentTabTitle,
    getDMParentTabTitle: getDMParentTabTitle,
    isDMParentMultipleKeySelected: isDMParentMultipleKeySelected,
    isFlightManagementGrid: isFlightManagementGrid
  };
};
GridRecordsNavigationService.$inject = [];
module.exports = GridRecordsNavigationService;